import { camelize } from "humps";
import { useMemo } from "react";
import { useParams } from "react-router-dom";

const useAppSection = () => {
  const params = useParams();

  const appSection = useMemo(() => {
    const section = camelize(params.section || "");
    if (
      [
        "home",
        "about",
        "team",
        "services",
        "projects",
        "contact",
        "quote",
      ].includes(section)
    ) {
      return section;
    }
    return "home";
  }, [params]);

  return appSection;
};

export default useAppSection;
